module.exports = __webpack_public_path__ + "img/card_medicaid_claims.7592e2f7.svg";